import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-1 bg-white rounded-lg" }
const _hoisted_2 = { class: "flex justify-between items-center" }
const _hoisted_3 = { class: "text-sm font-semibold text-gray-lp-300" }
const _hoisted_4 = { class: "flex items-center gap-1" }
const _hoisted_5 = { class: "text-12px font-semibold text-red-lp-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToggleV2 = _resolveComponent("ToggleV2")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t("pickupDashboard.manageArea.assignCourierTitle")), 1),
      _createVNode("div", _hoisted_4, [
        _createVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("pickupDashboard.manageArea.setShift")), 1),
        _createVNode(_component_ToggleV2, {
          modelValue: _ctx.isShiftEnabled,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:isShiftEnabled', $event))),
          customLabel: ""
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createVNode(_component_SelectSearch, {
      modelValue: _ctx.selectedCourier,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:selectedCourier', $event))),
      placeholder: _ctx.$t('pickupDashboard.manageArea.selectCourierPlaceholder'),
      options: _ctx.courierOptions,
      isLoading: _ctx.isLoading,
      useInfiniteScroll: "",
      keyName: "displayName",
      keyValue: "id",
      isDisabled: _ctx.isShiftEnabled,
      onFilter: _ctx.onSearch,
      onScrolled: _ctx.onScroll,
      class: "w-full",
      disabledBackground: _ctx.isShiftEnabled,
      errorMessage: _ctx.$t('pickupDashboard.manageArea.noCourierAvailable'),
      onClear: _ctx.onClear
    }, null, 8, ["modelValue", "placeholder", "options", "isLoading", "isDisabled", "onFilter", "onScrolled", "disabledBackground", "errorMessage", "onClear"])
  ]))
}